import { html } from 'lit';

export const formstackHtmlExample = html`<div>
  <script
    type="text/javascript"
    src="https://bellinhealth.formstack.com/forms/js.php/everything_bagel"
  ></script>
  <div class="fsBody fsEmbed">
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/3/reset_3d1cc6d59f.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/3/jquery-ui-1.12.1_f735107ad2.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/3/default-v4_29cde3be75.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/../common/css/uil-static.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/common/dialogs_00a7ec5f05.css"
    />
    <!--[if IE]>
      <link
        rel="stylesheet"
        type="text/css"
        media="all"
        href="https://bellinhealth.formstack.com/forms/css/3/ie.css?20140508"
      />
    <![endif]-->
    <!--[if IE 7
      ]><link
        rel="stylesheet"
        type="text/css"
        media="all"
        href="https://bellinhealth.formstack.com/forms/css/3/ie7.css"
    /><![endif]-->
    <!--[if IE 6
      ]><link
        rel="stylesheet"
        type="text/css"
        media="all"
        href="https://bellinhealth.formstack.com/forms/css/3/ie6fixes.css"
    /><![endif]-->
    <style type="text/css">
      @charset "UTF-8";
      .fsBody {
        font-family:
          'Helvetica Neue', Arial, 'Lucida Grande', Tahoma, Verdana, sans-serif;
        color: #232323;
      }
      .fsBody input,
      .fsBody select,
      .fsBody textarea {
        font-family:
          'Helvetica Neue', Arial, 'Lucida Grande', Tahoma, Verdana, sans-serif;
      }
      .wf-active .fsBody,
      .wf-active .fsBody input,
      .wf-active .fsBody select,
      .wf-active .fsBody textarea {
        font-family:
          'Abel', 'Helvetica Neue', Arial, 'Lucida Grande', Tahoma, Verdana,
          sans-serif;
      }
      .fsBody .fsForm {
        float: center;
        border: 0px solid transparent;
        background-color: #ffffff;
        background-color: rgba(255, 255, 255, 1);
      }
      #fsHeaderImage {
        text-align:;
      }
      #fsHeaderImage img {
        width:;
        height:;
      }
      #fsFooterImage {
        text-align:;
      }
      #fsFooterImage img {
        width:;
        height:;
      }
      .fsborderradius .fsBody .fsForm {
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
      }
      .fsBody {
        padding: 40px;
      }
      .fsBody .fsForm {
        margin: 40px auto;
        padding: 40px;
      }
      .fsBody .fsFieldRow {
        margin-bottom: 40px !important;
      }
      .fsBody .fsRowBody {
        margin-bottom: 40px !important;
      }
      .fsBody .fsSubField {
        margin-right: 20px;
      }
      @media (max-width: 40em) {
        .fsRow.fsFieldRow.fsLastRow {
          margin-bottom: 40px;
        }
        .fsSubFieldGroup .fsSubField:not(:last-child) {
          margin-bottom: 20px;
        }
      }
      .fsFieldFocused:not(.fsValidationError) {
        background-color: #ebf8ff;
        background-color: rgba(235, 248, 255, 1);
      }
      .fsFieldFocused:not(.fsValidationError).fsSpan100 {
        padding: 20px !important;
        margin: -20px -20px !important;
      }
      .fsFieldFocused:not(.fsValidationError).fsSpan75,
      .fsFieldFocused:not(.fsValidationError).fsSpan66,
      .fsFieldFocused:not(.fsValidationError).fsSpan50,
      .fsFieldFocused:not(.fsValidationError).fsSpan33,
      .fsFieldFocused:not(.fsValidationError).fsSpan25 {
        -webkit-box-shadow: 0 0 0 20px #ebf8ff;
        -moz-box-shadow: 0 0 0 20px #ebf8ff;
        box-shadow: 0 0 0 20px #ebf8ff;
        -webkit-box-shadow: 0 0 0 20px rgba(235, 248, 255, 1);
        -moz-box-shadow: 0 0 0 20px rgba(235, 248, 255, 1);
        box-shadow: 0 0 0 20px rgba(235, 248, 255, 1);
      }
      .fsRequiredMarker {
        margin-left: 5px !important;
        font-size: 18px;
        color: #dc2626;
      }
      .fsValidationError {
        background-color: #fae9e9;
        -webkit-box-shadow:
          0 0 0 calc(10px - 1px) #fae9e9,
          0 0 0 10px #ce5f6d;
        -moz-box-shadow:
          0 0 0 calc(10px - 1px) #fae9e9,
          0 0 0 10px #ce5f6d;
        box-shadow:
          0 0 0 calc(10px - 1px) #fae9e9,
          0 0 0 10px #ce5f6d;
      }
      .fsForm input:focus,
      .fsForm select:focus,
      .fsForm textarea:focus,
      .fsForm .ui-slider-handle:focus {
        border-color: #858585;
        -webkit-box-shadow: 0 0 5px rgba(, 0.75);
        -moz-box-shadow: 0 0 5px rgba(, 0.75);
        box-shadow: 0 0 5px rgba(, 0.75);
      }
      .fsForm :-moz-focusring {
        text-shadow: 0 0 0 #232323;
      }
      @media   screen {
        .fsForm input:focus,
        .fsForm select:focus,
        .fsForm textarea:focus {
          filter: progid:DXImageTransform.Microsoft.Shadow(Color=#232323, Strength=2, Direction=0) progid:DXImageTransform.Microsoft.Shadow(Color=#232323, Strength=2, Direction=90) progid:DXImageTransform.Microsoft.Shadow(Color=#232323, Strength=2, Direction=180) progid:DXImageTransform.Microsoft.Shadow(Color=#232323, Strength=2, Direction=270);
        }
      }
      div.fsError {
        margin: 0 0 40px 0;
        padding: 20px;
        font-size: 11px;
      }
      .fsBody .showMobile {
        margin-top: 20px;
        font-size: 14px;
      }
      .fsBody .fsLabel,
      .fsBody label {
        font-size: 16px;
        color: #232323;
      }
      .fsLabelVertical .fsLabel {
        margin-bottom: 20px;
      }
      .fsBody .fsSupporting {
        font-size: 14px;
        font-weight: 400;
        font-style: normal;
        line-height: 14px;
        color: #232323;
      }
      .fsFieldFocused div.fsSupporting {
        color: #232323;
      }
      .fsBody .fsCounter {
        font-size: 14px;
        color: #232323;
      }
      .fsForm .fsLabelHorizontal > label,
      .fsForm .fsLabelHorizontal > legend,
      .fsForm .fsLabelHorizontal > span.fsLabel,
      .fsForm .fsLabelHorizontal legend.fsLabelHorizontal {
        width: calc(25% - 20px);
        margin-right: 20px;
      }
      label.fsOptionLabel {
        font-size: 11px;
        line-height: 22px;
      }
      .fsBody .fieldset-content .fsOptionLabel.horizontal {
        margin-right: 40px;
      }
      @media all and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait),
        all and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {
        .fsOptionLabel {
          line-height: 32px !important;
        }
      }
      @media (max-width: 40em) {
        label.fsOptionLabel {
          border: 1px solid #858585;
          -webkit-border-radius: 3px;
          -moz-border-radius: 3px;
          -ms-border-radius: 3px;
          -o-border-radius: 3px;
          border-radius: 3px;
          background-color: #ffffff;
          color: #232323;
        }
      }
      .fsBody .fsCalloutTop {
        border-color: transparent transparent #232323 transparent;
      }
      .fsBody .fsCalloutBody {
        padding: 14px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        font-size: 14px;
        line-height: 28px;
        color: #ffffff;
        background-color: #232323;
      }
      .fsRowBody input[type='text'],
      .fsRowBody input[type='email'],
      .fsRowBody input[type='number'],
      .fsRowBody input[type='tel'],
      .fsForm textarea,
      .fsSignature {
        border: 1px solid #858585;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        background-color: #ffffff;
        -webkit-transition-property:
          color, background-color, border, border-color, box-shadow;
        -moz-transition-property:
          color, background-color, border, border-color, box-shadow;
        -o-transition-property:
          color, background-color, border, border-color, box-shadow;
        transition-property:
          color, background-color, border, border-color, box-shadow;
        -webkit-transition-duration: 0s;
        -moz-transition-duration: 0s;
        -o-transition-duration: 0s;
        transition-duration: 0s;
        -webkit-transition-timing-function: ease-in-out;
        -moz-transition-timing-function: ease-in-out;
        -o-transition-timing-function: ease-in-out;
        transition-timing-function: ease-in-out;
      }
      .fsRowBody input[type='text'],
      .fsRowBody input[type='email'],
      .fsRowBody input[type='number'],
      .fsRowBody input[type='tel'],
      .fsForm select {
        height: 33px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
      }
      .fsRowBody input[type='text'],
      .fsRowBody input[type='email'],
      .fsRowBody input[type='number'],
      .fsRowBody input[type='tel'],
      .fsForm select,
      .fsForm textarea {
        padding: 5.5px;
        font-size: 11px;
        font-weight: 400;
        font-style: normal;
        line-height: 11px;
        color: #232323;
      }
      .fsRowBody input[type='text'].fsRequired,
      .fsRowBody input[type='email'].fsRequired,
      .fsRowBody input[type='number'].fsRequired,
      .fsRowBody input[type='tel'].fsRequired,
      .fsForm select.fsRequired,
      .fsForm textarea.fsRequired {
        border: 1px solid #858585;
        background-color: #ffffff;
      }
      .fsCell {
        -webkit-transition-property:
          padding, box-shadow, background-color, margin-left, margin-right;
        -moz-transition-property:
          padding, box-shadow, background-color, margin-left, margin-right;
        -o-transition-property:
          padding, box-shadow, background-color, margin-left, margin-right;
        transition-property:
          padding, box-shadow, background-color, margin-left, margin-right;
        -webkit-transition-duration: 0s;
        -moz-transition-duration: 0s;
        -o-transition-duration: 0s;
        transition-duration: 0s;
        -webkit-transition-timing-function: ease-in-out;
        -moz-transition-timing-function: ease-in-out;
        -o-transition-timing-function: ease-in-out;
        transition-timing-function: ease-in-out;
      }
      .fsRowBody input[type='radio'],
      .fsRowBody input[type='checkbox'] {
        top: 5.5px;
        width: 11px;
        height: 11px;
      }
      .fsRowBody input[type='radio']:before,
      .fsRowBody input[type='radio']:checked:before,
      .fsRowBody input[type='checkbox']:before,
      .fsRowBody input[type='checkbox']:checked:before {
        width: 11px;
        height: 11px;
        margin-right: 5.5px;
        border: 1px solid #858585;
        background-color: #ffffff;
      }
      .fsRowBody input[type='radio']:checked:before {
        border: 4px solid #232323;
      }
      .fsRatingShape .phx-Icon {
        fill: #858585;
        height: 20px;
        width: 20px;
      }
      .fsRowBody input[type='checkbox']:checked:before {
        border-color: #232323;
        background-color: #232323;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 765.2'%3E%3Cpath fill='%23ffffff' d='M960,233.4L468.2,725.1c-53.4,53.4-140,53.4-193.3,0L40,490.3c-53.4-53.4-53.4-140,0-193.3c53.4-53.4,140-53.4,193.3,0	l138.2,138.2L766.6,40c53.4-53.4,140-53.4,193.3,0C1013.3,93.4,1013.3,180,960,233.4z'/%3E%3C/svg%3E");
      }
      .fsForm select {
        padding-right: calc(11px);
        padding-left: calc(5.5px);
        border: 1px solid #858585;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        color: #232323;
        background-color: #ffffff;
        -webkit-transition-property:
          color, background-color, border, border-color;
        -moz-transition-property: color, background-color, border, border-color;
        -o-transition-property: color, background-color, border, border-color;
        transition-property: color, background-color, border, border-color;
        -webkit-transition-duration: 0s;
        -moz-transition-duration: 0s;
        -o-transition-duration: 0s;
        transition-duration: 0s;
        -webkit-transition-timing-function: ease-in-out;
        -moz-transition-timing-function: ease-in-out;
        -o-transition-timing-function: ease-in-out;
        transition-timing-function: ease-in-out;
      }
      .fsForm select:not([multiple='multiple']) {
        padding-right: calc(22px);
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1805.18'%3E%3Cpath fill='%23232323' d='M461.6,643.4L10.9,79.9C-14.9,47.7,8,0,49.3,0h901.5c41.2,0,64.1,47.7,38.4,79.9L538.4,643.4	C518.7,668,481.3,668,461.6,643.4z' transform='rotate(180 500 902.59) translate(0 1143.28)'%3E%3C/path%3E%3Cpath fill='%23232323' d='M461.6,643.4L10.9,79.9C-14.9,47.7,8,0,49.3,0h901.5c41.2,0,64.1,47.7,38.4,79.9L538.4,643.4	C518.7,668,481.3,668,461.6,643.4z' transform='translate(0 1143.28)'%3E%3C/path%3E%3C/svg%3E");
        background-position: right 5.5px top 50%;
      }
      @media screen  {
        .fsForm select {
          padding-right: calc(11px) !important;
        }
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(2).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(1).fsNameFirst {
        width: calc(50% - 20px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(3).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(2).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(1).fsNameFirst {
        width: calc(40% - 20px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(3).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(3).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(3).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(3).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(2).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(2).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(2).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(2).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(1).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(1).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(1).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(1).fsNameSuffix {
        width: calc(20% - 20px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(4).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(3).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(2).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(1).fsNameFirst {
        width: calc(35% - 20px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(4).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(4).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(4).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(4).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(3).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(3).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(3).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(3).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(2).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(2).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(2).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(2).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(1).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(1).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(1).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(1).fsNameSuffix {
        width: calc(15% - 20px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(5).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(4).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(3).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(2).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(1).fsNameFirst {
        width: calc(32% - 20px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(5).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(5).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(5).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(5).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(4).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(4).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(4).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(4).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(3).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(3).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(3).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(3).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(2).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(2).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(2).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(2).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(1).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(1).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(1).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(1).fsNameSuffix {
        width: calc(12% - 20px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(6).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(5).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(4).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(3).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(2).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(6):nth-last-child(1).fsNameFirst {
        width: calc(28% - 20px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(6).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(6).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(6).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(6).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(5).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(5).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(5).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(5).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(4).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(4).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(4).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(4).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(3).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(3).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(3).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(3).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(2).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(2).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(2).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(2).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(6):nth-last-child(1).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(6):nth-last-child(1).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(6):nth-last-child(1).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(6):nth-last-child(1).fsNameSuffix {
        width: calc(11% - 20px);
      }
      .fsBody .fsSubField.fsFieldAddress {
        width: 100%;
      }
      .fsBody .fsSubField.fsFieldAddress2 {
        width: 100%;
      }
      .fsBody .fsSubField.fsFieldCity {
        width: calc(60% - 20px);
      }
      .fsBody .fsSubField.fsFieldState {
        width: calc(30% - 20px);
      }
      .fsBody .fsSubFieldGroup ~ select[name*='-country'] {
        margin-top: 20px !important;
      }
      .fsBody .fsSubField.fsFieldAddress,
      .fsBody .fsSubField.fsFieldAddress2 {
        margin-bottom: 20px;
      }
      @media all and (max-width: 699px),
        all and (device-height: 1024px) and (device-width: 768px) and (orientation: portrait),
        all and (device-height: 1024px) and (device-width: 768px) and (orientation: landscape) {
        .fsBody .fsSubField.fsFieldCity {
          margin-bottom: 20px;
        }
        .fsBody .fsSubField.fsFieldState {
          width: calc(70% - 20px);
        }
      }
      @media (max-width: 40em) {
        div.fsSubField.fsFieldState {
          margin-right: 20px;
        }
      }
      div.fsSliderValue {
        padding: 5.5px 11px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        font-size: 11px;
        line-height: 16px;
        color: #ffffff;
        background-color: #232323;
      }
      .fsSliderDiv {
        font-size: 11px;
        background-color: #232323;
      }
      .fsSliderDiv .ui-state-default,
      .fsSliderDiv .ui-widget-content .ui-state-default {
        background-color: #232323;
      }
      .fsSliderDiv .ui-state-active,
      .fsSliderDiv .ui-widget-content .ui-state-active {
        background-color: #232323;
      }
      .fsSliderDiv .ui-corner-all,
      .fsSliderDiv.ui-corner-all {
        -moz-border-radius-topleft: 3px;
        -webkit-border-top-left-radius: 3px;
        border-top-left-radius: 3px;
        -moz-border-radius-topright: 3px;
        -webkit-border-top-right-radius: 3px;
        border-top-right-radius: 3px;
        -moz-border-radius-bottomleft: 3px;
        -webkit-border-bottom-left-radius: 3px;
        border-bottom-left-radius: 3px;
        -moz-border-radius-bottomright: 3px;
        -webkit-border-bottom-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }
      .fsSliderDiv.ui-widget-content {
        border: 1px solid #858585 !important;
      }
      .fsSliderDiv .ui-widget-header {
        background-color: #858585;
      }
      .fsCurrency {
        margin-right: 10px !important;
        font-size: 11px;
        line-height: 32px;
        color: #232323;
      }
      .fsCurrency.fsCurrencySuffix {
        margin-right: 0 !important;
        margin-left: 10px !important;
      }
      .fsCurrency ~ input.fsField {
        width: calc(96% - 10px) !important;
      }
      .fsRowBody input[type='email'] ~ p {
        margin-top: 20px;
      }
      @font-face {
        font-family: 'TextMask';
        src: url('/forms/fonts/3/password.ttf') format('truetype');
        font-weight: 400;
        font-style: normal;
      }
      .fsTextMask {
        font-family: 'TextMask' !important;
      }
      .fsRowBody input[type='text'] ~ p {
        margin-top: 20px;
      }
      .fsProductField__fields__quantity {
        color: #232323;
      }
      .fsProductField__fields__fixed-amount,
      .fsProductField__fields__no-charge {
        font-size: 11px;
        color: #232323;
      }
      .fsProductField__info__name {
        font-size: 16px;
        color: #232323;
      }
      .fsProductField__info__description {
        margin-top: 10px;
        font-size: 14px;
        line-height: 14px;
        color: #232323;
      }
      .fsProductField__fields__sold-out {
        font-size: 11px;
        color: #dc2626;
      }
      .fsProductField__wait-list {
        margin-top: 20px;
      }
      @media (max-width: 40em) {
        .fsProductField__image {
          -webkit-border-radius: 3px;
          -moz-border-radius: 3px;
          -ms-border-radius: 3px;
          -o-border-radius: 3px;
          border-radius: 3px;
        }
        .fsProductField__fields__fixed-amount,
        .fsProductField__fields__quantity {
          font-size: 11px;
        }
      }
      .fsMatrix {
        font-size: 14px;
        color: #232323;
      }
      .fsMatrix th,
      .fsMatrix td {
        border-top: 1px solid #858585;
        border-left: 1px solid #858585;
      }
      .fsMatrix th:nth-child(2) {
        -webkit-border-radius: 3px 0 0 0;
        -moz-border-radius: 3px 0 0 0;
        -ms-border-radius: 3px 0 0 0;
        -o-border-radius: 3px 0 0 0;
        border-radius: 3px 0 0 0;
      }
      .fsMatrix tr:first-child th:last-child {
        -webkit-border-radius: 0 3px 0 0;
        -moz-border-radius: 0 3px 0 0;
        -ms-border-radius: 0 3px 0 0;
        -o-border-radius: 0 3px 0 0;
        border-radius: 0 3px 0 0;
      }
      .fsMatrix tr:last-child td:last-child {
        -webkit-border-radius: 0 0 3px 0;
        -moz-border-radius: 0 0 3px 0;
        -ms-border-radius: 0 0 3px 0;
        -o-border-radius: 0 0 3px 0;
        border-radius: 0 0 3px 0;
      }
      .fsMatrix tr:last-child th {
        -webkit-border-radius: 0 0 0 3px;
        -moz-border-radius: 0 0 0 3px;
        -ms-border-radius: 0 0 0 3px;
        -o-border-radius: 0 0 0 3px;
        border-radius: 0 0 0 3px;
      }
      .fsMatrix tr:last-child th,
      .fsMatrix tr:last-child td {
        border-bottom: 1px solid #858585;
      }
      .fsMatrix tr th:last-child,
      .fsMatrix tr td:last-child {
        border-right: 1px solid #858585;
      }
      .fsMatrix th.fsMatrixLabelColumn {
        text-align: center;
      }
      .fsMatrix th.fsMatrixLabelRow {
        text-align: right;
      }
      .fsMatrix th.fsMatrixLabelColumn,
      .fsMatrix th.fsMatrixLabelRow {
        padding: 7px;
      }
      .fsMatrixCol1 {
        background: #858585;
        background: rgba(133, 133, 133, 0.2);
      }
      .fsMatrixCol2 {
        background: #858585;
        background: rgba(133, 133, 133, 0.2);
      }
      .rtl .fsMatrix th,
      .rtl .fsMatrix td {
        border-right: 1px solid #858585;
      }
      .fsForm input[type='file']::-webkit-file-upload-button,
      .fsForm .fsFileUploadButton {
        height: 32px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        font-size: 11px;
        color: #ffffff;
        background-color: #232323;
      }
      .fsFileUploadName {
        font-size: 11px;
      }
      .fsBody .fieldset-content .always-ltr {
        margin-top: 20px;
      }
      .fsBody .fieldset-content select span,
      .fsBody .fieldset-content .always-ltr span,
      .fsBody .fieldset-content .always-ltr-align-right span {
        top: 8px;
      }
      .fsBody .fieldset-content select {
        margin-right: 20px;
      }
      .fsBody .fieldset-content span {
        right: 10px;
      }
      .fsBody .ui-datepicker-trigger {
        top: 8px;
        margin-left: 20px;
      }
      .fsSignatureClear {
        font-size: 14px;
        color: #232323;
      }
      .fsSignature + div {
        margin-left: 20px;
        line-height: 14px;
      }
      .wf-active .fsSignature {
        font-family: Arial, Tahoma, sans-serif;
      }
      img.fsCreditCardLogo {
        margin-top: 10px;
      }
      .fsBody .fsSectionHeader {
        background-color: #ffffff;
      }
      .fsBody .fsForm .fsSectionHeading {
        margin-bottom: 20px;
        text-align: left;
        font-size: 24px;
        font-weight: 400;
        font-style: normal;
        line-height: 24px;
        color: #232323;
      }
      .fsborderradius .fsBody .fsSectionHeader {
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
      }
      .fsborderradius .fsBody .fsSectionHeader {
        margin-bottom: 80px;
      }
      .fsBody .fsSectionHeader {
        padding: 40px;
      }
      .fsForm select[multiple='multiple']::-webkit-scrollbar-thumb,
      .fsForm textarea::-webkit-scrollbar-thumb {
        background-color: #858585;
      }
      .fsForm .fsSubmit {
        margin-top: 80px;
        padding: 40px 0;
      }
      .fsPreviousButton,
      .fsSubmitButton,
      .fsNextButton {
        padding: 12px 22px;
        border: 0px solid transparent;
        -webkit-border-radius: 3px !important;
        -moz-border-radius: 3px !important;
        -ms-border-radius: 3px !important;
        -o-border-radius: 3px !important;
        border-radius: 3px !important;
        font-size: 16px !important;
        font-weight: 400;
        font-style: normal;
        line-height: 16px;
        color: #ffffff !important;
        background-color: #007cc2 !important;
      }
      div.fsProgress {
        margin-top: 40px;
      }
      div.fsProgressBarContainer {
        height: 16px;
        background-color: #858585;
      }
      div.fsProgressText {
        margin-top: -16px;
        font-size: 8px;
        line-height: 16px;
        color: #232323;
      }
      div.fsProgressBar {
        background-color: #858585;
      }
      div.fsSaveIncomplete {
        margin-bottom: 40px;
        padding: 20px 0;
        background-color: #858585;
      }
      div.fsSaveIncomplete a {
        font-size: 11px;
        color: #232323;
      }
      div.fsSaveIncomplete a:visited {
        color: #232323;
      }
      @media all and (max-width: 699px),
        all and (device-height: 1024px) and (device-width: 768px) and (orientation: portrait),
        all and (device-height: 1024px) and (device-width: 768px) and (orientation: landscape) {
        .fsPagination .fsNextButton,
        .fsPagination .fsPreviousButton {
          background-color: #007cc2;
        }
        .fsPagination .fsSubmitMultipage {
          margin-top: 40px !important;
        }
      }
      #fsSubmissionCheckmark {
        margin: 20px 0;
        background-image:
          linear-gradient(transparent, transparent),
          url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath fill='%23232323' d='M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M749.4,423	L495.6,676.8c-27.6,27.6-72.2,27.6-99.8,0L274.7,555.6c-27.6-27.6-27.6-72.2,0-99.8c27.6-27.6,72.2-27.6,99.8,0l71.3,71.3	l203.9-203.9c27.6-27.6,72.2-27.6,99.8,0C777,350.8,777,395.5,749.4,423z'/%3E%3C/svg%3E");
      }
      #fsSubmissionCheckmark ~ .fsSectionHeading {
        margin-bottom: 20px;
      }
      #fsSubmissionCheckmark ~ .fsSectionText {
        text-align: left;
      }
      #recaptcha_area {
        margin-bottom: 40px;
      }
      .recaptchatable img:hover {
        -webkit-box-shadow: 0px 0px 0px 1px #dc2626;
        -moz-box-shadow: 0px 0px 0px 1px #dc2626;
        box-shadow: 0px 0px 0px 1px #dc2626;
      }
      .fsForm .fsWorkflowSendBack {
        margin-top: 40px;
        font-size: 16px;
      }
      .fsForm .fsWorkflowSendBack a {
        text-decoration: underline;
        cursor: pointer;
      }
      .fsForm .fsWorkflowSendBack svg {
        margin-bottom: -2px;
        width: 14px;
        height: 14px;
        fill: #232323;
      }
      .fsEmbed .fsWelcomeMessage {
        position: relative;
      }
      .fsWelcomeMessage:not(.fsWelcomeMessage--hidden) + form.fsForm {
        display: none;
      }
      .fsWelcomeMessage--hidden + form.fsForm {
        display: inherit;
      }
      .fsWelcomeMessage {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        padding: 0;
        z-index: 99999;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      .fsWelcomeMessage.fsWelcomeMessage--hidden {
        display: none;
      }
      .fsWelcomeMessage .fsWelcomeMessage__header {
        position: absolute;
        width: 180px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left center;
        height: 82px;
        z-index: 10;
        margin-left: 19px;
        top: 2px;
        left: 0;
      }
      .fsWelcomeMessage .fsWelcomeMessage__image {
        background-repeat: no-repeat;
        background-size: unset;
        background-position: center;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 8;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__image.fsWelcomeMessage__sizing--repeat {
        background-repeat: repeat;
        background-size: unset;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__image.fsWelcomeMessage__sizing--contain {
        background-size: contain;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__image.fsWelcomeMessage__sizing--cover {
        background-size: cover;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__image.fsWelcomeMessage__sizing--stretch {
        background-size: 100% 100%;
      }
      .fsWelcomeMessage .fsWelcomeMessage__content {
        z-index: 9;
        background-color: #ffffff;
        padding: 80px;
        margin: 20px;
        border-radius: 3px;
        position: relative;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__content.fsWelcomeMessage__content--hide-form-background {
        background-color: transparent;
      }
      .fsWelcomeMessage .fsWelcomeMessage__content .fsWelcomeMessage__message {
        color: #232323;
        font-size: 24px;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__content
        .fsWelcomeMessage__start-button {
        padding: 12px 22px;
        margin-top: 80px;
        border: 0px solid transparent;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        font-size: 16px;
        font-weight: 400;
        font-style: normal;
        line-height: 16px;
        color: #ffffff;
        background-color: #007cc2;
        cursor: pointer;
      }
      html:not([data-scroll='0']) .survey-mode.fsBody .fsForm .survey-header {
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
      }
      .survey-mode.fsBody #fsHeaderImage {
        transition: all 0.1s;
        position: fixed;
        width: 180px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left center;
        height: 82px;
        z-index: 10;
        margin: 2px 0 0 19px;
        top: 0;
        left: 0;
      }
      .survey-mode.fsBody #fsHeaderImage.fsHeaderImage--relative {
        display: none;
      }
      .survey-mode.fsBody .fsHeaderImage--sticky {
        transition: all 0.1s;
        position: absolute;
        width: 180px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left center;
        height: 82px;
        z-index: 10;
        margin-left: 19px;
        bottom: 2px;
        left: 0;
      }
      .survey-mode.fsBody .payment-warning {
        margin-top: 61px;
        margin-left: 7px;
        margin-right: 7px;
      }
      .survey-mode.fsBody .fsSignatureClear {
        text-decoration: none;
        background: #fff;
        color: #000;
        padding: 7px 12px;
        border-radius: 3px;
        text-transform: capitalize;
      }
      .survey-mode.fsBody [fs-field-type='signature'] .fsSupporting {
        clear: left;
        margin-left: 12px;
        margin-top: 9px;
        line-height: 1.5;
      }
      .survey-mode.fsBody .fsForm {
        margin-top: 140px !important;
        min-width: inherit;
        width: 100%;
        background-color: #ffffff;
        border: none;
        max-width: 1024px;
      }
      .survey-mode.fsBody .fsForm .g-recaptcha .grecaptcha-badge {
        z-index: 9;
      }
      .survey-mode.fsBody
        .fsForm.with-ads:not(.fsgo-form)
        .g-recaptcha
        .grecaptcha-badge {
        bottom: 54px !important;
      }
      .survey-mode.fsBody .fsForm.with-ads:not(.fsgo-form) .fsProgress {
        bottom: 40px;
      }
      .survey-mode.fsBody .fsForm .fsSignature + div {
        margin-top: 7px;
        line-height: 1.5;
      }
      .survey-mode.fsBody .fsForm .fsProgress {
        position: fixed;
        border: 0;
        bottom: 0;
        left: 0;
        z-index: 11;
      }
      .survey-mode.fsBody .fsForm .fsProgress div.fsProgressText {
        display: none;
      }
      .survey-mode.fsBody .fsForm .fsProgress div.fsProgressBar {
        transition: width 1s;
      }
      .survey-mode.fsBody .fsForm .survey-header {
        background-color: #ffffff;
        z-index: 9;
        box-sizing: border-box;
        position: fixed;
        width: 100%;
        top: -1px;
        left: 0;
        height: 88px;
        display: flex;
        align-items: flex-end;
        padding: 19px;
        transition: all 0.1s linear;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header.with-progressbar
        div.shareLinksWrapper {
        margin-bottom: 11px;
      }
      .survey-mode.fsBody .fsForm .survey-header .fsSubmit.fsPagination {
        position: relative;
        flex: 1;
        padding: 0;
        margin: 0 0 7px 0;
        display: flex;
        justify-content: flex-end;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        span.fsFull {
        display: none;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsSubmitButton {
        display: inline-block;
        width: auto;
        margin: 0 !important;
        height: 44px;
        padding: 0 30px;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsNextButton,
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsPreviousButton,
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsSubmitButton {
        margin-right: 29px;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsNextButton,
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsPreviousButton {
        width: 41px;
        height: 41px;
        padding: 0;
        -webkit-border-radius: 50% !important;
        -moz-border-radius: 50% !important;
        -ms-border-radius: 50% !important;
        -o-border-radius: 50% !important;
        border-radius: 50% !important;
        user-select: none;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsSlim {
        display: none;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsNextButton:before,
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsPreviousButton:before {
        display: block;
        text-indent: 0;
        font-size: 1.5em;
        line-height: 0;
        font-family: 'Zapf Dingbats';
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsNextButton:before {
        content: '➤';
        margin-left: 3px;
        margin-top: 3px;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsPreviousButton:before {
        content: '➤';
        transform: rotate(180deg);
        margin-left: -3px;
      }
      .rtl
        .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsNextButton:before {
        content: '➤';
        transform: rotate(180deg);
      }
      .rtl
        .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsPreviousButton:before {
        content: '➤';
      }
      @media all and (max-width: 1024px) {
        .survey-mode.fsBody .fsHeaderImage.fsHeaderImage--relative {
          display: none;
        }
        .survey-mode.fsBody .payment-warning {
          margin-top: 91px;
        }
        .survey-mode.fsBody #fsFooterImage {
          margin-bottom: 61px;
        }
        .survey-mode.fsBody .fsForm label.fsOptionLabel {
          color: #232323;
        }
        .survey-mode.fsBody .fsForm .survey-header .fsSubmit.fsPagination {
          margin-top: 0 !important;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsProgress {
          margin-top: 0;
          position: fixed;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          div.shareLinksWrapper {
          margin-bottom: 12px;
        }
        .survey-mode.fsBody .fsForm .fsFieldHighlight.fsSubFieldGroup {
          flex-direction: column;
        }
        .survey-mode.fsBody
          .fsForm
          [fs-field-type='address']
          .fsSubFieldGroup
          .fsSubField {
          width: 100%;
          margin-bottom: 15px;
        }
        .survey-mode.fsBody
          .fsForm
          [fs-field-type='address']
          .fsFieldHighlight
          > select {
          margin-top: 0 !important;
        }
        .survey-mode.fsBody
          .fsForm
          [fs-field-type='address']
          .fsFieldHighlight
          > label {
          margin-top: 7px;
        }
        .survey-mode.fsBody .fsForm [fs-field-type='name'] .fsSubField {
          width: 100%;
        }
        .survey-mode.fsBody
          .fsForm
          [fs-field-type='name']
          .fsSubField:not(:last-child) {
          margin-bottom: 20px;
        }
      }
      @media all and (max-width: 480px) {
        .survey-mode.fsBody #fsHeaderImage {
          position: relative;
          transform: scale(0.8);
          transform-origin: left center;
          height: 51px;
        }
        .survey-mode.fsBody #fsHeaderImage.fsHeaderImage--relative {
          display: block;
        }
        .survey-mode.fsBody .fsHeaderImage--sticky {
          display: none;
        }
        .survey-mode.fsBody .payment-warning {
          margin-top: 11px;
        }
        .survey-mode.fsBody #fsFooterImage {
          margin-bottom: 121px;
        }
        .survey-mode.fsBody .fsForm {
          position: relative;
          margin-top: 0 !important;
          padding: 30px 19px;
          margin-bottom: 20px !important;
          overflow: hidden;
        }
        .survey-mode.fsBody .fsForm .reportAbuse {
          margin-bottom: 51px !important;
        }
        .survey-mode.fsBody .fsForm .g-recaptcha .grecaptcha-badge {
          bottom: 64px !important;
        }
        .survey-mode.fsBody
          .fsForm.with-ads:not(.fsgo-form)
          .g-recaptcha
          .grecaptcha-badge {
          bottom: 104px !important;
        }
        .survey-mode.fsBody .fsForm.with-ads:not(.fsgo-form) .survey-header {
          bottom: 40px;
        }
        .survey-mode.fsBody .fsForm .fsRatingFieldContainer svg.phx-Icon {
          max-height: 60px;
        }
        .survey-mode.fsBody .fsForm .fsRatingFieldContainer .fsRatingPipButton {
          margin: 0 2px;
        }
        .survey-mode.fsBody .fsForm .fsSignature {
          margin: 0 -12px;
        }
        .survey-mode.fsBody .fsForm .survey-header {
          padding: 12px;
          height: 51px;
          margin: 0;
          position: fixed;
          bottom: 0;
          left: 0;
          top: unset;
          box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.25);
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsHeaderImage.fsHeaderImage--sticky {
          display: none;
        }
        .survey-mode.fsBody .fsForm .survey-header.with-progressbar {
          padding: 12px 12px 22px;
          height: 61px;
        }
        .survey-mode.fsBody .fsForm .survey-header .fsSubmit.fsPagination {
          justify-content: space-between;
          margin-bottom: 0;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          div.shareLinksWrapper {
          margin-bottom: 59px;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsProgress {
          position: fixed;
          margin-top: 0;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsProgress
          .fsProgressBarContainer {
          height: 12px;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsSubmitButton {
          height: 31px;
          padding: 7px;
          margin-left: auto !important;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsNextButton {
          margin-left: auto;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsNextButton,
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsPreviousButton,
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsSubmitButton {
          margin-right: 12px;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsNextButton,
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsPreviousButton {
          width: 31px;
          height: 31px;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsNextButton:before,
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsPreviousButton:before {
          font-size: 1.3em;
        }
      }
      .survey-mode .fsForm .fsFieldFocused:not(.fsValidationError) {
        background-color: transparent;
      }
      .survey-mode .fsForm .fsFieldFocused:not(.fsValidationError).fsSpan100 {
        margin: 0 !important;
        padding: 0 !important;
      }
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError).fsSpan100.fsRowBody {
        margin-bottom: 40px !important;
      }
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError)
        .fsFieldHighlight {
        background-color: rgba(235, 248, 255, 1);
      }
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError)
        .fsFieldHighlight::after {
        background-color: rgba(235, 248, 255, 1);
      }
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError)
        .fsOptionLabel:focus,
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError)
        .fsOptionLabel:active {
        background-color: rgba(235, 248, 255, 1);
      }
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError)
        .fsOptionLabel {
        -webkit-tap-highlight-color: rgba(235, 248, 255, 0.3);
      }
      .survey-mode .fsForm .fieldset-content label.fsOptionLabel {
        background-color: #ffffff;
      }
      .survey-mode .fsForm .fsSubField label.fsSupporting {
        margin-top: 7px;
      }
      .survey-mode .fsForm .fsSubField.fsFieldCity {
        padding: 0;
      }
      .survey-mode .fsForm .fsSubField.fsSubField.fsFieldState {
        padding: 0;
      }
      .survey-mode .fsForm .fsSubField.fsFieldZip {
        padding: 0;
      }
      .survey-mode .fsForm .fsRatingFieldContainer {
        box-sizing: border-box;
        border-radius: 6px;
        display: flex;
      }
      .survey-mode .fsForm .fsRatingFieldContainer svg.phx-Icon {
        max-height: 100px;
        max-width: 100px;
        height: auto;
        width: 100%;
      }
      .survey-mode .fsForm .fsRatingFieldContainer .fsRatingPipButton {
        margin: 25px 5px;
        flex: 1;
        max-width: 133px;
      }
      .survey-mode .fsForm .fsRatingFieldContainer .fsRatingPipButton:focus {
        opacity: 1;
      }
      .survey-mode .fsForm .fsFieldHighlight {
        background-color: #ffffff;
        padding: 19px;
        box-sizing: border-box;
        border-radius: 3px;
        z-index: 5;
        position: relative;
      }
      .survey-mode .fsForm .fsFieldHighlight::before {
        background-color: #ffffff;
        border-radius: 3px;
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: -1;
        left: 0;
        top: 0;
      }
      .survey-mode .fsForm .fsFieldHighlight::after {
        transition: background-color 0.4s;
        background-color: #ffffff;
        border-radius: 3px;
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: -1;
        left: 0;
        top: 0;
      }
      .survey-mode .fsForm .fsFieldHighlight.fsSubFieldGroup {
        display: flex;
      }
      .survey-mode .fsForm [fs-field-type='address'] .fsFieldHighlight {
        margin-bottom: 20px;
      }
      .survey-mode .fsForm [fs-field-type='address'] .fsFieldHighlight > label {
        margin-top: 7px;
      }
      .survey-mode .fsForm [fs-field-type='datetime'] .fsFieldHighlight::after {
        clear: both;
        content: '';
        display: table;
      }
      .survey-mode .fsForm table.fsMatrix td {
        padding: 19px 0;
      }
      .survey-mode .fsForm table.fsMatrix th {
        padding: 19px 6.5px;
      }
      .survey-mode .fsForm label.fsOptionLabel {
        display: block;
        margin: 0.5em 0;
        padding: 0.5em 1em;
        line-height: 22px !important;
        cursor: pointer;
      }
      .survey-mode .fsForm label.fsOptionLabel.horizontal {
        float: none;
        margin: 0.5em 0;
        margin-right: 0 !important;
      }
      .survey-mode .fsForm label.fsOptionLabel.horizontal ~ div.horizontal {
        display: block !important;
        margin-top: 0 !important;
      }
      .survey-mode .fsForm label.fsOptionLabel.vertical ~ div.vertical {
        margin-top: 0 !important;
      }
      .survey-mode .fsForm .fieldset-content .fsOptionLabel:first-child {
        margin-top: 0;
      }
      .survey-mode
        .fsForm
        .rtl
        .fsFieldRow
        .fieldset-content
        .fsOptionLabel.horizontal {
        float: none !important;
        margin: 0 0 0 20px;
      }
      .fsSubmissionMessageImage {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        padding: 0;
        z-index: 99999;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      .fsSubmissionMessageImage.fsSubmissionMessageImage--hidden {
        display: none;
      }
      .fsSubmissionMessageImage .fsSubmissionMessageImage__header {
        position: absolute;
        width: 180px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left center;
        height: 82px;
        z-index: 10;
        margin-left: 19px;
        top: 2px;
        left: 0;
      }
      .fsSubmissionMessageImage .fsSubmissionMessageImage__image {
        background-repeat: no-repeat;
        background-size: unset;
        background-position: center;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 8;
      }
      .fsSubmissionMessageImage
        .fsSubmissionMessageImage__image.fsSubmissionMessageImage__sizing--repeat {
        background-repeat: repeat;
        background-size: unset;
      }
      .fsSubmissionMessageImage
        .fsSubmissionMessageImage__image.fsSubmissionMessageImage__sizing--contain {
        background-size: contain;
      }
      .fsSubmissionMessageImage
        .fsSubmissionMessageImage__image.fsSubmissionMessageImage__sizing--cover {
        background-size: cover;
      }
      .fsSubmissionMessageImage
        .fsSubmissionMessageImage__image.fsSubmissionMessageImage__sizing--stretch {
        background-size: 100% 100%;
      }
      .fsSubmissionMessageImage .fsSubmissionMessageImage__content {
        z-index: 9;
        background-color: #ffffff;
        padding: 80px;
        margin: 20px;
        border-radius: 3px;
        position: relative;
      }
      .fsSubmissionMessageImage
        .fsSubmissionMessageImage__content.fsSubmissionMessageImage__content--hide-form-background {
        background-color: transparent;
      }
    </style>
    <style type="text/css">
      /*Trying to make a passing attempt at making Formstack accessible.*/
      input:focus,
      select:focus,
      textarea:focus {
        /*his formstack functionality appears to be broken,
so we manually write it here. Note Formstack throws an error
here, but the css works.*/
        border-color: var(--focus_highlight_color) !important;
      }
      input[type='radio']:focus:before,
      input[type='checkbox']:focus:before,
      input[type='button']:focus,
      input[type='submit']:focus {
        /*Try to make checkboxes and radio buttons accessible*/
        outline: 2px solid var(--focus_highlight_color) !important;
        outline-offset: 2px !important;
      }
      input[type='radio'],
      input[type='checkbox'] {
        /*Fix formstack's funky radio buttons*/
        overflow: visible !important;
      }
      input[type='checkbox']:checked:before {
        background-color: var(--button_bgcolor) !important;
        border-color: var(--button_bgcolor) !important;
      }
      input[type='radio']:checked:before {
        border-color: var(--button_bgcolor) !important;
      }
    </style>
    <form
      method="post"
      accept-charset="UTF-8"
      novalidate=""
      enctype="multipart/form-data"
      action="https://bellinhealth.formstack.com/forms/index.php"
      class="fsForm fsSingleColumn"
      id="fsForm5288078"
    >
      <input type="hidden" name="form" value="5288078" />
      <input type="hidden" name="viewkey" value="WPVJ5WcWAD" />
      <input type="hidden" name="password" value="" />
      <input
        type="hidden"
        name="hidden_fields"
        id="hidden_fields5288078"
        value=""
      />
      <input type="hidden" name="incomplete" id="incomplete5288078" value="" />
      <input
        type="hidden"
        name="incomplete_password"
        id="incomplete_password5288078"
      />
      <input
        type="hidden"
        name="referrer"
        id="referrer5288078"
        value="https://dev.bellin.org/"
      />
      <input
        type="hidden"
        name="referrer_type"
        id="referrer_type5288078"
        value="js"
      />
      <input type="hidden" name="_submit" value="1" />
      <input type="hidden" name="style_version" value="3" />
      <input type="hidden" id="viewparam" name="viewparam" value="1009840" />
      <div id="requiredFieldsError" style="display:none;">
        Please fill in a valid value for all required fields
      </div>
      <div id="invalidFormatError" style="display:none;">
        Please ensure all values are in a proper format.
      </div>
      <div id="resumeConfirm" style="display:none;">
        Are you sure you want to leave this form and resume later?
      </div>
      <div id="resumeConfirmPassword" style="display: none;">
        Are you sure you want to leave this form and resume later? If so, please
        enter a password below to securely save your form.
      </div>
      <div id="saveAndResume" style="display: none;">Save and Resume Later</div>
      <div id="saveResumeProcess" style="display: none;">Save and get link</div>
      <div id="fileTypeAlert" style="display:none;">
        You must upload one of the following file types for the selected field:
      </div>
      <div id="embedError" style="display:none;">
        There was an error displaying the form. Please copy and paste the embed
        code again.
      </div>
      <div id="applyDiscountButton" style="display:none;">Apply Discount</div>
      <div id="dcmYouSaved" style="display:none;">You saved</div>
      <div id="dcmWithCode" style="display:none;">with code</div>
      <div id="submitButtonText" style="display:none;">Submit Form</div>
      <div id="submittingText" style="display:none;">Submitting</div>
      <div id="validatingText" style="display:none;">Validating</div>
      <div id="autocaptureDisabledText" style="display:none;"></div>
      <div id="paymentInitError" style="display:none;">
        There was an error initializing the payment processor on this form.
        Please contact the form owner to correct this issue.
      </div>
      <div id="checkFieldPrompt" style="display:none;">
        Please check the field:
      </div>
      <div id="translatedWord-fields" style="display:none;">Fields</div>
      <div class="fsPage" id="fsPage5288078-1">
        <div
          id="ReactContainer5288078"
          style="display:none"
          class="FsReactContainerInitApp"
          data-fs-react-app-id="5288078"
        ></div>

        <div class="fsSection fs1Col" id="fsSection144654393">
          <div class="fsSectionHeader">
            <h2 class="fsSectionHeading">The Everything Bagel</h2>

            <div class="fsSectionText">
              <p>
                Please fill out all the required fields and attach your resume
                below.
              </p>
            </div>
          </div>

          <div id="fsRow5288078-2" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654502"
              lang="en"
              fs-field-type="datetime"
              fs-field-validation-name="Date/Time"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend144654502"
                id="label144654502"
              >
                <legend id="fsLegend144654502" class="fsLabel fsLabelVertical">
                  <span>Date/Time</span>
                </legend>
                <div class="fieldset-content">
                  <!-- Used to pull in url for jquery -->
                  <span
                    aria-hidden="true"
                    style="display:none;"
                    id="fsCalendar144654502ImageUrl"
                    >https://bellinhealth.formstack.com/forms/images/2/calendar.png</span
                  >

                  <input
                    data-skip-validation=""
                    data-date-format="M d, Y"
                    type="hidden"
                    id="field144654502Format"
                    name="field144654502Format"
                    value="MDY"
                  />

                  <div class="hidden">
                    <label for="field144654502M">Month</label>
                  </div>
                  <select
                    id="field144654502M"
                    name="field144654502M"
                    class=" fsField"
                  >
                    <option value=""></option>
                    <option value="Jan">Jan</option>
                    <option value="Feb">Feb</option>
                    <option value="Mar">Mar</option>
                    <option value="Apr">Apr</option>
                    <option value="May">May</option>
                    <option value="Jun">Jun</option>
                    <option value="Jul">Jul</option>
                    <option value="Aug">Aug</option>
                    <option value="Sep">Sep</option>
                    <option value="Oct">Oct</option>
                    <option value="Nov">Nov</option>
                    <option value="Dec">Dec</option>
                  </select>
                  <div class="hidden">
                    <label for="field144654502D">Day</label>
                  </div>
                  <select
                    id="field144654502D"
                    name="field144654502D"
                    class=" fsField"
                  >
                    <option value=""></option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                  <div class="hidden">
                    <label for="field144654502Y">Year</label>
                  </div>
                  <select
                    id="field144654502Y"
                    name="field144654502Y"
                    class=" fsField"
                  >
                    <option value=""></option>
                    <option value="2018">2018</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                  </select>

                  <input
                    data-skip-validation=""
                    type="text"
                    id="fsCalendar144654502Link"
                    class="fsCalendarPickerLink hasDatepicker"
                    style="display:none;"
                    aria-hidden="true"
                  /><img
                    class="ui-datepicker-trigger"
                    src="https://bellinhealth.formstack.com/forms/images/2/calendar.png"
                    alt="Select Date"
                    title="Select Date"
                    aria-hidden="true"
                  />
                  <div
                    id="fsCalendar144654502"
                    class="fsCalendar"
                    style=" position:absolute"
                  ></div>

                  <span class="always-ltr">
                    <div class="hidden">
                      <label for="field144654502H">Hour</label>
                    </div>
                    <select
                      id="field144654502H"
                      name="field144654502H"
                      class="fsField"
                    >
                      <option value=""></option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    <div class="hidden">
                      <label for="field144654502I">Minute</label>
                    </div>
                    <span>:</span>
                    <select
                      id="field144654502I"
                      name="field144654502I"
                      class="fsField"
                    >
                      <option value=""></option>
                      <option value="00">00</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">31</option>
                      <option value="32">32</option>
                      <option value="33">33</option>
                      <option value="34">34</option>
                      <option value="35">35</option>
                      <option value="36">36</option>
                      <option value="37">37</option>
                      <option value="38">38</option>
                      <option value="39">39</option>
                      <option value="40">40</option>
                      <option value="41">41</option>
                      <option value="42">42</option>
                      <option value="43">43</option>
                      <option value="44">44</option>
                      <option value="45">45</option>
                      <option value="46">46</option>
                      <option value="47">47</option>
                      <option value="48">48</option>
                      <option value="49">49</option>
                      <option value="50">50</option>
                      <option value="51">51</option>
                      <option value="52">52</option>
                      <option value="53">53</option>
                      <option value="54">54</option>
                      <option value="55">55</option>
                      <option value="56">56</option>
                      <option value="57">57</option>
                      <option value="58">58</option>
                      <option value="59">59</option>
                    </select>

                    &nbsp;
                    <div class="hidden">
                      <label for="field144654502A">AM/PM</label>
                    </div>
                    <select
                      id="field144654502A"
                      name="field144654502A"
                      class="fsField"
                    >
                      <option value=""></option>
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                    <div class="fs-clear"></div>
                  </span>
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5288078-3" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654394"
              lang="en"
              fs-field-type="name"
              fs-field-validation-name="Name"
            >
              <span id="label144654394" class="fsLabel fsRequiredLabel"
                >Name<span class="fsRequiredMarker">*</span></span
              >

              <div class="fsSubFieldGroup">
                <div class="fsSubField fsNameFirst">
                  <input
                    type="text"
                    id="field144654394-first"
                    name="field144654394-first"
                    size="20"
                    aria-label="First Name"
                    value=""
                    required=""
                    class="fsField fsFieldName fsRequired"
                    aria-required="true"
                  />
                  <label
                    class="fsSupporting fsRequiredLabel"
                    for="field144654394-first"
                    >First Name<span class="hidden">*</span></label
                  >
                </div>

                <div class="fsSubField fsNameLast">
                  <input
                    type="text"
                    id="field144654394-last"
                    name="field144654394-last"
                    size="20"
                    aria-label="Last Name"
                    value=""
                    required=""
                    class="fsField fsFieldName fsRequired"
                    aria-required="true"
                  />
                  <label
                    class="fsSupporting fsRequiredLabel"
                    for="field144654394-last"
                    >Last Name<span class="hidden">*</span></label
                  >
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>

          <div id="fsRow5288078-4" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654395"
              lang="en"
              fs-field-type="address"
              fs-field-validation-name="Address"
            >
              <span id="label144654395" class="fsLabel">Address</span>

              <div class="fsSubFieldGroup">
                <div class="fsSubField fsFieldAddress">
                  <input
                    type="text"
                    id="field144654395-address"
                    aria-label="Address Line 1"
                    name="field144654395-address"
                    size="50"
                    value=""
                    class="fsField fsFieldAddress"
                  />
                  <label class="fsSupporting" for="field144654395-address"
                    >Address Line 1</label
                  >
                </div>

                <div class="fsSubField fsFieldAddress2">
                  <input
                    type="text"
                    id="field144654395-address2"
                    aria-label="Address Line 2"
                    name="field144654395-address2"
                    size="50"
                    value=""
                    class="fsField fsFieldAddress2"
                  />
                  <label class="fsSupporting" for="field144654395-address2"
                    >Address Line 2</label
                  >
                </div>

                <div class="fsSubField fsFieldCity">
                  <input
                    type="text"
                    id="field144654395-city"
                    name="field144654395-city"
                    size="15"
                    aria-label="City"
                    value=""
                    class="fsField fsFieldCity"
                  />
                  <label class="fsSupporting" for="field144654395-city"
                    >City</label
                  >
                </div>

                <div class="fsSubField fsFieldState">
                  <select
                    id="field144654395-state"
                    aria-label="State"
                    name="field144654395-state"
                    class="fsField fsFieldState"
                  >
                    <option value="">&nbsp;</option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="GU">Guam</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VI">Virgin Islands (US)</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                    <option value="AA">Armed Forces (the) Americas</option>
                    <option value="AE">Armed Forces Europe</option>
                    <option value="AP">Armed Forces Pacific</option>
                    <option value="APO">
                      Army Post Office (U.S. Army and U.S. Air Force)
                    </option>
                    <option value="FPO">
                      Fleet Post Office (U.S. Navy and U.S. Marine Corps)
                    </option>
                  </select>
                  <label class="fsSupporting" for="field144654395-state"
                    >State</label
                  >
                </div>

                <div class="fsSubField fsFieldZip">
                  <input
                    type="text"
                    id="field144654395-zip"
                    aria-label="ZIP Code"
                    name="field144654395-zip"
                    size="6"
                    value=""
                    class="fsField fsFieldZip fsFormatZipUS"
                  />
                  <label class="fsSupporting" for="field144654395-zip"
                    >ZIP Code</label
                  >
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>

          <div id="fsRow5288078-5" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654396"
              lang="en"
              fs-field-type="phone"
              fs-field-validation-name="Home Phone"
            >
              <label id="label144654396" class="fsLabel" for="field144654396"
                >Home Phone
              </label>

              <input
                type="tel"
                id="field144654396"
                name="field144654396"
                size="15"
                value=""
                class="fsField fsFormatPhoneUS "
                data-country="US"
                data-format="national"
              />
            </div>
          </div>

          <div id="fsRow5288078-6" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654397"
              lang="en"
              fs-field-type="email"
              fs-field-validation-name="Email"
            >
              <label id="label144654397" class="fsLabel" for="field144654397"
                >Email
              </label>

              <input
                type="email"
                id="field144654397"
                name="field144654397"
                size="50"
                value=""
                class="fsField fsFormatEmail"
              />
            </div>
          </div>

          <div id="fsRow5288078-7" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654398"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Position Applying For"
            >
              <label id="label144654398" class="fsLabel" for="field144654398"
                >Position Applying For
              </label>

              <input
                type="text"
                id="field144654398"
                name="field144654398"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>
          </div>

          <div id="fsRow5288078-8" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654399"
              lang="en"
              fs-field-type="radio"
              fs-field-validation-name="Employment Desired"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend144654399"
                id="label144654399"
              >
                <legend id="fsLegend144654399" class="fsLabel fsLabelVertical">
                  <span>Employment Desired</span>
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel horizontal" for="field144654399_1"
                    ><input
                      type="radio"
                      id="field144654399_1"
                      name="field144654399"
                      value="Full-time"
                      class="fsField horizontal"
                    />Full-time</label
                  >

                  <label class="fsOptionLabel horizontal" for="field144654399_2"
                    ><input
                      type="radio"
                      id="field144654399_2"
                      name="field144654399"
                      value="Part-time"
                      class="fsField horizontal"
                    />Part-time</label
                  >

                  <label class="fsOptionLabel horizontal" for="field144654399_3"
                    ><input
                      type="radio"
                      id="field144654399_3"
                      name="field144654399"
                      value="Either"
                      class="fsField horizontal"
                    />Either</label
                  >
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5288078-9" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654400"
              lang="en"
              fs-field-type="number"
              fs-field-validation-name="How man hours can you work weekly?"
            >
              <label id="label144654400" class="fsLabel" for="field144654400"
                >How man hours can you work weekly?
              </label>

              <input
                type="number"
                step="any"
                id="field144654400"
                name="field144654400"
                class="fsField fsFormatNumber fsNumberDecimals-0"
              />

              <script>
                //This script is to address some quirkiness of Safari where commas are interchangeable with decimal points on number fields.
                //Normal attempts to restrict the comma such as our own validation or .replace(",", "") results in the value of the field being removed entirely.
                //Below the keypress itself is being blocked as a workaround to keep our value.
                document
                  .getElementById('field144654400')
                  .addEventListener('keydown', function blockComma(e) {
                    if (e.code === 'Comma') {
                      e.preventDefault();
                    }
                  });
              </script>
            </div>
          </div>

          <div id="fsRow5288078-10" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654401"
              lang="en"
              fs-field-type="radio"
              fs-field-validation-name="Can you work nights?"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend144654401"
                id="label144654401"
              >
                <legend id="fsLegend144654401" class="fsLabel fsLabelVertical">
                  <span>Can you work nights?</span>
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel horizontal" for="field144654401_1"
                    ><input
                      type="radio"
                      id="field144654401_1"
                      name="field144654401"
                      value="Yes"
                      class="fsField horizontal"
                    />Yes</label
                  >

                  <label class="fsOptionLabel horizontal" for="field144654401_2"
                    ><input
                      type="radio"
                      id="field144654401_2"
                      name="field144654401"
                      value="No"
                      class="fsField horizontal"
                    />No</label
                  >
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5288078-11" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654402"
              lang="en"
              fs-field-type="radio"
              fs-field-validation-name="Are you 18 or older?"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend144654402"
                id="label144654402"
              >
                <legend id="fsLegend144654402" class="fsLabel fsLabelVertical">
                  <span>Are you 18 or older?</span>
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel horizontal" for="field144654402_1"
                    ><input
                      type="radio"
                      id="field144654402_1"
                      name="field144654402"
                      value="Yes"
                      class="fsField horizontal"
                    />Yes</label
                  >

                  <label class="fsOptionLabel horizontal" for="field144654402_2"
                    ><input
                      type="radio"
                      id="field144654402_2"
                      name="field144654402"
                      value="No"
                      class="fsField horizontal"
                    />No</label
                  >
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div class="fsPage fsHiddenPage" id="fsPage5288078-2">
        <div class="fsSection fsFirstSection fs1Col" id="fsSection144654403">
          <div class="fsSectionHeader"></div>

          <div id="fsRow5288078-13" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654404"
              lang="en"
              fs-field-type="radio"
              fs-field-validation-name="Have you ever been convicted of a felony?"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend144654404"
                id="label144654404"
              >
                <legend id="fsLegend144654404" class="fsLabel fsLabelVertical">
                  <span>Have you ever been convicted of a felony?</span>
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel horizontal" for="field144654404_1"
                    ><input
                      type="radio"
                      id="field144654404_1"
                      name="field144654404"
                      value="Yes"
                      class="fsField horizontal"
                    />Yes</label
                  >

                  <label class="fsOptionLabel horizontal" for="field144654404_2"
                    ><input
                      type="radio"
                      id="field144654404_2"
                      name="field144654404"
                      value="No"
                      class="fsField horizontal"
                    />No</label
                  >
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5288078-14" class="fsRow fsFieldRow fsLastRow fsHidden">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsHidden fsSpan100"
              id="fsCell144654405"
              lang="en"
              fs-field-type="textarea"
              fs-field-validation-name="If yes, explain number of conviction(s), nature of offense(s) leading to conviction(s), how recently such offense(s) was/were committed, sentence(s) imposed, and type(s) of rehabilitation."
            >
              <label id="label144654405" class="fsLabel" for="field144654405"
                >If yes, explain number of conviction(s), nature of offense(s)
                leading to conviction(s), how recently such offense(s) was/were
                committed, sentence(s) imposed, and type(s) of rehabilitation.
              </label>

              <textarea
                id="field144654405"
                class="fsField "
                name="field144654405"
                rows="10"
                cols="50"
                disabled="disabled"
              ></textarea>
            </div>
          </div>

          <div id="fsRow5288078-15" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654406"
              lang="en"
              fs-field-type="radio"
              fs-field-validation-name="I certify that I am a U.S. citizen, permanent resident, or a foreign national with authorization to work in the United States."
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend144654406"
                id="label144654406"
              >
                <legend id="fsLegend144654406" class="fsLabel fsLabelVertical">
                  <span
                    >I certify that I am a U.S. citizen, permanent resident, or
                    a foreign national with authorization to work in the United
                    States.</span
                  >
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel horizontal" for="field144654406_1"
                    ><input
                      type="radio"
                      id="field144654406_1"
                      name="field144654406"
                      value="Yes"
                      class="fsField horizontal"
                    />Yes</label
                  >

                  <label class="fsOptionLabel horizontal" for="field144654406_2"
                    ><input
                      type="radio"
                      id="field144654406_2"
                      name="field144654406"
                      value="No"
                      class="fsField horizontal"
                    />No</label
                  >
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5288078-16" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654407"
              lang="en"
              fs-field-type="radio"
              fs-field-validation-name="How did you find out about this position?"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend144654407"
                id="label144654407"
              >
                <legend id="fsLegend144654407" class="fsLabel fsLabelVertical">
                  <span>How did you find out about this position?</span>
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel vertical" for="field144654407_1"
                    ><input
                      type="radio"
                      id="field144654407_1"
                      name="field144654407"
                      value="Current Employee"
                      class="fsField vertical"
                    />Current Employee</label
                  >

                  <label class="fsOptionLabel vertical" for="field144654407_2"
                    ><input
                      type="radio"
                      id="field144654407_2"
                      name="field144654407"
                      value="Career Fair"
                      class="fsField vertical"
                    />Career Fair</label
                  >

                  <label class="fsOptionLabel vertical" for="field144654407_3"
                    ><input
                      type="radio"
                      id="field144654407_3"
                      name="field144654407"
                      value="Newspaper Ad"
                      class="fsField vertical"
                    />Newspaper Ad</label
                  >

                  <label class="fsOptionLabel vertical" for="field144654407_4"
                    ><input
                      type="radio"
                      id="field144654407_4"
                      name="field144654407"
                      value="Radio/TV Ad"
                      class="fsField vertical"
                    />Radio/TV Ad</label
                  >

                  <label class="fsOptionLabel vertical" for="field144654407_5"
                    ><input
                      type="radio"
                      id="field144654407_5"
                      name="field144654407"
                      value="Search Engine"
                      class="fsField vertical"
                    />Search Engine</label
                  >

                  <div class="vertical fs-clear">
                    <label
                      class="fsOptionLabel vertical"
                      for="field144654407_other"
                      ><input
                        type="radio"
                        id="field144654407_other"
                        name="field144654407"
                        value="Other"
                        class="fsField"
                      />Other:</label
                    >
                    <input
                      type="text"
                      id="field144654407_othervalue"
                      name="field144654407_other"
                      size="15"
                      class="fsOtherField"
                    /><label
                      class="fsHiddenLabel"
                      style="display: none;"
                      for="field144654407_othervalue"
                      >Other Value</label
                    >
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5288078-17" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654408"
              lang="en"
              fs-field-type="file"
              fs-field-validation-name="Upload your resume"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend144654408"
                id="label144654408"
              >
                <legend id="fsLegend144654408" class="fsLabel fsLabelVertical">
                  <span>Upload your resume</span>
                </legend>
                <div class="fieldset-content">
                  <input
                    type="file"
                    style="display: none"
                    id="field144654408"
                    name="field144654408"
                    size="50"
                    class="fsField fsUpload uploadTypes-jpg,jpeg,gif,png,bmp,tif,psd,pdf,doc,docx,xls,txt,mp3,mp4,aac,wav,au,wmv,avi,mpg,mpeg,zip,gz,rar,z,tgz,tar,sitx"
                  />
                  <input
                    type="button"
                    class="fsFileUploadButton"
                    id="field144654408UploadButton"
                    aria-controls="field144654408"
                    value="Choose File"
                  />
                  <input
                    type="button"
                    class="fsFileUploadButton"
                    id="field144654408DeleteButton"
                    aria-controls="field144654408"
                    value="Remove File"
                  />
                  <span class="fsFileUploadName" id="field144654408FileName"
                    >No File Chosen</span
                  >
                  <div class="showMobile">
                    File uploads may not work on some mobile devices.
                  </div>
                  <script>
                    (function () {
                      var filename = document.getElementById(
                        'field144654408FileName'
                      ).innerHTML;
                      function fileUploadClick() {
                        var field = document.getElementById('field144654408');
                        field.click();
                      }
                      function fileDelete() {
                        document.getElementById('field144654408').value = '';
                        document.getElementById(
                          'field144654408FileName'
                        ).innerHTML = filename;
                      }
                      function onFileChange(event) {
                        if (!event.target.files || !event.target.files.length) {
                          return;
                        }
                        var file = event.target.files[0];
                        var name = document.getElementById(
                          'field144654408FileName'
                        );
                        name.innerHTML = file.name;
                      }
                      var button = document.getElementById(
                        'field144654408UploadButton'
                      );
                      button.addEventListener('click', fileUploadClick);
                      var field = document.getElementById('field144654408');
                      field.addEventListener('change', onFileChange);
                      var buttonDelete = document.getElementById(
                        'field144654408DeleteButton'
                      );
                      buttonDelete.addEventListener('click', fileDelete);
                    })();
                  </script>
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5288078-18" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654409"
              lang="en"
              fs-field-type="file"
              fs-field-validation-name="Upload a cover letter (optional)"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend144654409"
                id="label144654409"
              >
                <legend id="fsLegend144654409" class="fsLabel fsLabelVertical">
                  <span>Upload a cover letter (optional)</span>
                </legend>
                <div class="fieldset-content">
                  <input
                    type="file"
                    style="display: none"
                    id="field144654409"
                    name="field144654409"
                    size="50"
                    class="fsField fsUpload uploadTypes-jpg,jpeg,gif,png,bmp,tif,psd,pdf,doc,docx,xls,txt,mp3,mp4,aac,wav,au,wmv,avi,mpg,mpeg,zip,gz,rar,z,tgz,tar,sitx"
                  />
                  <input
                    type="button"
                    class="fsFileUploadButton"
                    id="field144654409UploadButton"
                    aria-controls="field144654409"
                    value="Choose File"
                  />
                  <input
                    type="button"
                    class="fsFileUploadButton"
                    id="field144654409DeleteButton"
                    aria-controls="field144654409"
                    value="Remove File"
                  />
                  <span class="fsFileUploadName" id="field144654409FileName"
                    >No File Chosen</span
                  >
                  <div class="showMobile">
                    File uploads may not work on some mobile devices.
                  </div>
                  <script>
                    (function () {
                      var filename = document.getElementById(
                        'field144654409FileName'
                      ).innerHTML;
                      function fileUploadClick() {
                        var field = document.getElementById('field144654409');
                        field.click();
                      }
                      function fileDelete() {
                        document.getElementById('field144654409').value = '';
                        document.getElementById(
                          'field144654409FileName'
                        ).innerHTML = filename;
                      }
                      function onFileChange(event) {
                        if (!event.target.files || !event.target.files.length) {
                          return;
                        }
                        var file = event.target.files[0];
                        var name = document.getElementById(
                          'field144654409FileName'
                        );
                        name.innerHTML = file.name;
                      }
                      var button = document.getElementById(
                        'field144654409UploadButton'
                      );
                      button.addEventListener('click', fileUploadClick);
                      var field = document.getElementById('field144654409');
                      field.addEventListener('change', onFileChange);
                      var buttonDelete = document.getElementById(
                        'field144654409DeleteButton'
                      );
                      buttonDelete.addEventListener('click', fileDelete);
                    })();
                  </script>
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5288078-19" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654410"
              lang="en"
              fs-field-type="textarea"
              fs-field-validation-name="Additional info (optional)"
            >
              <label id="label144654410" class="fsLabel" for="field144654410"
                >Additional info (optional)
              </label>

              <textarea
                id="field144654410"
                class="fsField "
                name="field144654410"
                rows="10"
                cols="50"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="fsSection fs1Col" id="fsSection144654458">
          <div class="fsSectionHeader"></div>

          <div id="fsRow5288078-21" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144654878"
              lang="en"
              fs-field-type="matrix"
              fs-field-validation-name="Matrix"
            >
              <fieldset
                id="matrix-field144654878-fieldset"
                aria-labelledby="fsLegend144654878"
                role="group"
                class="fsMatrixFieldset"
              >
                <legend id="fsLegend144654878" class="fsLabel fsLabelVertical">
                  <span>Matrix</span>
                </legend>

                <table id="matrix-field144654878" class="fsMatrix">
                  <caption style="height: 0;width: 0;overflow: hidden">
                    Matrix
                  </caption>
                  <tbody>
                    <tr>
                      <th scope="col" class="fsMatrixColCount4">&nbsp;</th>
                      <th
                        scope="col"
                        class="fsMatrixLabel fsMatrixLabelColumn fsMatrixCol1 fsMatrixColCount4"
                      >
                        Column 1
                      </th>
                      <th
                        scope="col"
                        class="fsMatrixLabel fsMatrixLabelColumn fsMatrixCol2 fsMatrixColCount4"
                      >
                        Column 2
                      </th>
                      <th
                        scope="col"
                        class="fsMatrixLabel fsMatrixLabelColumn fsMatrixCol1 fsMatrixColCount4"
                      >
                        Column 3
                      </th>
                    </tr>
                    <tr>
                      <th class="fsMatrixLabel fsMatrixLabelRow" scope="row">
                        Row 1
                      </th>
                      <td class="fsMatrixCol1 fsMatrixColCount4">
                        <label class="hidden" for="field144654878-1-1"
                          >Matrix: Row 1 (Column 1)</label
                        >
                        <input
                          type="radio"
                          id="field144654878-1-1"
                          name="field144654878-1"
                          value="Row 1 = Column 1"
                          class="fsField"
                        />
                      </td>
                      <td class="fsMatrixCol2 fsMatrixColCount4">
                        <label class="hidden" for="field144654878-1-2"
                          >Row 1 (Column 2)</label
                        >
                        <input
                          type="radio"
                          id="field144654878-1-2"
                          name="field144654878-1"
                          value="Row 1 = Column 2"
                          class="fsField"
                        />
                      </td>
                      <td class="fsMatrixCol1 fsMatrixColCount4">
                        <label class="hidden" for="field144654878-1-3"
                          >Row 1 (Column 3)</label
                        >
                        <input
                          type="radio"
                          id="field144654878-1-3"
                          name="field144654878-1"
                          value="Row 1 = Column 3"
                          class="fsField"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th class="fsMatrixLabel fsMatrixLabelRow" scope="row">
                        Row 2
                      </th>
                      <td class="fsMatrixCol1 fsMatrixColCount4">
                        <label class="hidden" for="field144654878-2-1"
                          >Row 2 (Column 1)</label
                        >
                        <input
                          type="radio"
                          id="field144654878-2-1"
                          name="field144654878-2"
                          value="Row 2 = Column 1"
                          class="fsField"
                        />
                      </td>
                      <td class="fsMatrixCol2 fsMatrixColCount4">
                        <label class="hidden" for="field144654878-2-2"
                          >Row 2 (Column 2)</label
                        >
                        <input
                          type="radio"
                          id="field144654878-2-2"
                          name="field144654878-2"
                          value="Row 2 = Column 2"
                          class="fsField"
                        />
                      </td>
                      <td class="fsMatrixCol1 fsMatrixColCount4">
                        <label class="hidden" for="field144654878-2-3"
                          >Row 2 (Column 3)</label
                        >
                        <input
                          type="radio"
                          id="field144654878-2-3"
                          name="field144654878-2"
                          value="Row 2 = Column 3"
                          class="fsField"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th class="fsMatrixLabel fsMatrixLabelRow" scope="row">
                        Row 3
                      </th>
                      <td class="fsMatrixCol1 fsMatrixColCount4">
                        <label class="hidden" for="field144654878-3-1"
                          >Row 3 (Column 1)</label
                        >
                        <input
                          type="radio"
                          id="field144654878-3-1"
                          name="field144654878-3"
                          value="Row 3 = Column 1"
                          class="fsField"
                        />
                      </td>
                      <td class="fsMatrixCol2 fsMatrixColCount4">
                        <label class="hidden" for="field144654878-3-2"
                          >Row 3 (Column 2)</label
                        >
                        <input
                          type="radio"
                          id="field144654878-3-2"
                          name="field144654878-3"
                          value="Row 3 = Column 2"
                          class="fsField"
                        />
                      </td>
                      <td class="fsMatrixCol1 fsMatrixColCount4">
                        <label class="hidden" for="field144654878-3-3"
                          >Row 3 (Column 3)</label
                        >
                        <input
                          type="radio"
                          id="field144654878-3-3"
                          name="field144654878-3"
                          value="Row 3 = Column 3"
                          class="fsField"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5288078-22" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144655069"
              lang="en"
              fs-field-type="select"
              fs-field-validation-name="Dropdown List"
            >
              <label id="label144655069" class="fsLabel" for="field144655069"
                >Dropdown List
              </label>

              <select
                id="field144655069"
                name="field144655069"
                size="1"
                class="fsField"
              >
                <option value="Option1">Option1</option>
                <option value="Option2">Option2</option>
                <option value="Option3">Option3</option>
              </select>
            </div>
          </div>

          <div id="fsRow5288078-23" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144655070"
              lang="en"
              fs-field-type="checkbox"
              fs-field-validation-name="Checkbox"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend144655070"
                id="label144655070"
              >
                <legend id="fsLegend144655070" class="fsLabel fsLabelVertical">
                  <span>Checkbox</span>
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel vertical" for="field144655070_1"
                    ><input
                      type="checkbox"
                      id="field144655070_1"
                      name="field144655070[]"
                      value="Option1"
                      class="fsField vertical"
                    />Option1</label
                  >
                  <label class="fsOptionLabel vertical" for="field144655070_2"
                    ><input
                      type="checkbox"
                      id="field144655070_2"
                      name="field144655070[]"
                      value="Option2"
                      class="fsField vertical"
                    />Option2</label
                  >
                  <label class="fsOptionLabel vertical" for="field144655070_3"
                    ><input
                      type="checkbox"
                      id="field144655070_3"
                      name="field144655070[]"
                      value="Option3"
                      class="fsField vertical"
                    />Option3</label
                  >
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5288078-24" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144655074"
              lang="en"
              fs-field-type="richtext"
              fs-field-validation-name=""
            >
              <p>Text area for description or disclaimer text to go here.</p>
            </div>
          </div>

          <div id="fsRow5288078-25" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144655080"
              lang="en"
              fs-field-type="product"
              fs-field-validation-name="Product"
            >
              <div class="fsProductField">
                <div
                  class="fsProductField__info fsProductField__info--no-image"
                >
                  <div class="fsProductField__info__name">Product</div>
                  <div class="fsProductField__info__description">
                    Product description goes here
                  </div>
                </div>
                <div class="fsProductField__fields">
                  <div class="fsProductField__fields__fixed-amount">$ 3.99</div>

                  <div class="fsProductField__fields__quantity">
                    <label for="field144655080">Quantity:</label>
                    <select
                      id="field144655080"
                      name="field144655080[quantity]"
                      data-type="product-quantity"
                      data-product-price="3.99"
                      class="field144655080Subfield fsField"
                    >
                      <option value="" selected="" disabled="">--</option>

                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                    </select>
                  </div>
                </div>

                <div class="clear"></div>
              </div>
            </div>
          </div>

          <div id="fsRow5288078-26" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144655081"
              aria-describedby="fsSupporting144655081"
              lang="en"
              fs-field-type="signature"
              fs-field-validation-name="Signature"
            >
              <label id="label144655081" class="fsLabel" for="field144655081"
                >Signature
              </label>

              <!--[if lt IE 9]>
                <script
                  type="text/javascript"
                  src="//formstack.com/forms/js/3/jsignature/flashcanvas.js"
                ></script>
              <![endif]-->
              <!--[if gte IE 9]>
<script type="text/javascript">

if (document.documentMode < 9){
    var url = '<script type="text/javascript" src="' + '//formstack.com/forms/' + 'js/3/jsignature/flashcanvas.js"></script>';
    document.write(url);
}

</script>
<![endif]-->
              <div id="signature144655081" class="fsSignature">
                <div
                  style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1em !important;margin-bottom:1em !important;"
                ></div>
                <canvas
                  style="margin: 0px; padding: 0px; border: none; height: 0px; width: 100%;"
                  class="jSignature"
                  width="0"
                  height="0"
                ></canvas>
                <div
                  style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1.5em !important;margin-bottom:1.5em !important;"
                ></div>
              </div>
              <div style="text-align: right">
                <a
                  href="javascript://"
                  class="fsSignatureClear"
                  id="signatureClear144655081"
                >
                  [clear]
                </a>
              </div>
              <input
                type="hidden"
                id="field144655081"
                value=""
                name="field144655081"
                class="fsField"
              />
              <div id="fsSupporting144655081" class="fsSupporting">
                Use your mouse or finger to draw your signature above
              </div>
            </div>
          </div>

          <div id="fsRow5288078-27" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell144900310"
              lang="en"
              fs-field-type="embed"
              fs-field-validation-name=""
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2845.6313298206687!2d-88.01427452316975!3d44.502220471074686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8802e52cc44c3dc1%3A0xd005992c54521b!2sBellin%20Hospital!5e0!3m2!1sen!2sus!4v1684356940804!5m2!1sen!2sus"
                width="600"
                height="450"
                style="border:0;"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div id="fsSubmit5288078" class="fsSubmit fsPagination">
        <button
          type="button"
          id="fsPreviousButton5288078"
          class="fsPreviousButton"
          value="Previous Page"
          style="display:none;"
          aria-label="Previous"
        >
          <span class="fsFull">Previous</span><span class="fsSlim">←</span>
        </button>
        <button
          type="button"
          id="fsNextButton5288078"
          class="fsNextButton"
          value="Next Page"
          style=""
          aria-label="Next"
        >
          <span class="fsFull">Next</span><span class="fsSlim">→</span>
        </button>
        <input
          id="fsSubmitButton5288078"
          class="fsSubmitButton fsSubmitMultipage"
          style="display: none;"
          type="submit"
          value="Submit Form"
        />

        <div class="clear"></div>
        <div class="withAds"></div>
      </div>
      <script type="text/javascript">
        window.FS_FIELD_DATA_5288078 = [];
      </script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/jquery-3.5.1.min_dc5e7f18c8.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/jquery-ui-1.12.1.min_d71fd11517.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/scripts_2d59c4c019.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/analytics_7d49daa365.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/jsignature/jSignature.min_6651ad6080.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/libphonenumber-min_6f64debfdd.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/modernizr_60a2d5aeb5.js"
      ></script>

      <script type="text/javascript">
        (function () {
          var isLocalStorageSafe = true;
          try {
            if (
              typeof sessionStorage !== 'undefined' &&
              sessionStorage.fsFonts
            ) {
              document.documentElement.className =
                document.documentElement.className += ' wf-active';
            }
          } catch (e) {
            console.log('Failed to read from localStorage', e.message);
            isLocalStorageSafe = false;
          }
          var pre = document.createElement('link');
          pre.rel = 'preconnect';
          pre.href = 'https://fonts.googleapis.com/';
          pre.setAttribute('crossorigin', '');
          var s = document.getElementsByTagName('head')[0];
          s.appendChild(pre);
          var fontConfig = {
            google: {
              families: ['Abel:400,700'],
            },
            timeout: 2000,
            active: function () {
              if (
                !isLocalStorageSafe ||
                typeof sessionStorage === 'undefined'
              ) {
                return;
              }
              sessionStorage.fsFonts = true;
            },
          };
          if (typeof WebFont === 'undefined') {
            window.WebFontConfig = fontConfig;
            var wf = document.createElement('script');
            wf.type = 'text/javascript';
            wf.async = 'true';
            wf.src =
              ('https:' == document.location.protocol ? 'https' : 'http') +
              '://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
            s.appendChild(wf);
          } else {
            WebFont.load(fontConfig);
          }
        })();

        if (window.addEventListener) {
          window.addEventListener('load', loadFormstack, false);
        } else if (window.attachEvent) {
          window.attachEvent('onload', loadFormstack);
        } else {
          loadFormstack();
        }

        function loadFormstack() {
          var form5288078 = new Formstack.Form(
            5288078,
            'https://bellinhealth.formstack.com/forms/'
          );

          form5288078.checks.push({
            target: '144654405',
            action: 'Show',
            bool: 'AND',
            fields: ['144654404'],
            checks: [{ field: '144654404', condition: '==', option: 'Yes' }],
          });

          form5288078.logicFields = ['144654404'];

          form5288078.calcFields = [];

          form5288078.dateCalcFields = [];
          form5288078.init();
          if (Formstack.Analytics) {
            form5288078.plugins.analytics = new Formstack.Analytics(
              'https://bellinhealth.formstack.com',
              5288078,
              form5288078
            );
            form5288078.plugins.analytics.trackTouch();
            form5288078.plugins.analytics.trackBottleneck();
          }

          window.form5288078 = form5288078;
        }
      </script>
      <script>
        function onSubmit() {
          grecaptcha.ready(function () {
            grecaptcha
              .execute('6LeINU0bAAAAAFIQNz4Bc_d7mbDzeBMENU3LBZN_', {
                action: 'submit',
              })
              .then(function (token) {
                document.getElementById('fsForm5288078').submit();
              });
          });
        }
      </script>
      <script src="https://www.google.com/recaptcha/api.js?render=6LeINU0bAAAAAFIQNz4Bc_d7mbDzeBMENU3LBZN_"></script>
      <div
        class="g-recaptcha"
        aria-hidden="true"
        data-sitekey="6LeINU0bAAAAAFIQNz4Bc_d7mbDzeBMENU3LBZN_"
        data-callback="onSubmit"
        data-size="invisible"
      >
        <div
          class="grecaptcha-badge"
          data-style="none"
          style="width: 256px; height: 60px; position: fixed; visibility: hidden;"
        >
          <div class="grecaptcha-logo">
            <iframe
              title="reCAPTCHA"
              src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LeINU0bAAAAAFIQNz4Bc_d7mbDzeBMENU3LBZN_&amp;co=aHR0cHM6Ly9kZXYuYmVsbGluLm9yZzo0NDM.&amp;hl=en&amp;v=SglpK98hSCn2CroR0bKRSJl5&amp;size=invisible&amp;cb=hv36kvqiwycc"
              width="256"
              height="60"
              role="presentation"
              name="a-cav6yd9ioq0c"
              frameborder="0"
              scrolling="no"
              sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox"
            ></iframe>
          </div>
          <div class="grecaptcha-error"></div>
          <textarea
            id="g-recaptcha-response"
            name="g-recaptcha-response"
            class="g-recaptcha-response"
            style="width: 250px; height: 40px; border: 1px solid rgb(193, 193, 193); margin: 10px 25px; padding: 0px; resize: none; display: none;"
          ></textarea>
        </div>
        <iframe style="display: none;"></iframe>
      </div>
      <input
        name="fsUserAgent"
        id="fsUserAgent"
        type="hidden"
        value="Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36"
      />
    </form>
    <div
      class="fs-ngdialog fs-modal-small fs-form-dialog fs-form-dialog--hidden"
    >
      <div class="fs-ngdialog-overlay"></div>
      <div class="fs-ngdialog-content">
        <div class="fs-modal__top fs-form-dialog__title"></div>
        <div class="fs-modal__middle">
          <div class="fs-form-dialog__message"></div>
          <label class="hidden" for="fsSaveResumePassword"
            >Enter your save and resume password</label
          >
          <input
            type="password"
            id="fsSaveResumePassword"
            class="fs-form-input fs-form-dialog__password fs-form-dialog--hidden fs--mt20"
            placeholder="Enter your save and resume password"
          />
          <textarea
            class="fs-form-dialog__textarea fs-form-dialog--hidden"
            rows="3"
            style="width: 100%; margin-top: 10px"
            aria-label="Add an optional comment"
          ></textarea>
        </div>
        <div class="fs-modal__bottom">
          <a
            class="fs-form-dialog__cancel fs-btn2 fs-btn2--size_medium fs-btn2--style_edit-dark"
            title="Cancel"
          >
            <div class="fs-btn2__content">
              <div class="fs-btn2__text">
                <span class="fs-form-dialog__button-text">Cancel</span>
              </div>
            </div>
          </a>
          <a
            class="fs-form-dialog__confirm fs-btn2 fs-btn2--size_medium fs-btn2--style_create fs--float-right"
            title="Confirm"
          >
            <div class="fs-btn2__content">
              <div class="fs-btn2__text">
                <span class="fs-form-dialog__button-text">Confirm</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <noscript
    ><a
      href="https://bellinhealth.formstack.com/forms/everything_bagel"
      title="Online Form"
      >Online Form - Everything Bagel</a
    ></noscript
  >
  <div style="text-align:right; font-size:x-small;">
    <a
      href="http://www.formstack.com?utm_source=jsembed&amp;utm_medium=product&amp;utm_campaign=product+branding&amp;fa=h,5288078"
      title="Powered by Formstack"
      >Powered by Formstack</a
    >
  </div>
</div>`;
